export default __webpack_public_path__ + "static/media/Targetaudience.51f66e9dc95a4e52ecc67a7271dd9a33.svg";